var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "design-bar-row", attrs: { id: "design-bar" } },
    [
      _c("div", { staticClass: "design-bar-column" }, [
        _c("div", { staticClass: "design-bar-cell design-bar-row" }, [
          _c("div", { staticClass: "design-bar-column" }, [
            _c("div", { staticClass: "design-bar-cell" }, [
              _c("input", {
                staticClass: "undo-button",
                attrs: { type: "button", value: "<" },
                on: { click: _vm.dispatch_undo }
              }),
              _vm._v(" "),
              _c("input", {
                staticClass: "redo-button",
                attrs: { type: "button", value: ">" },
                on: { click: _vm.dispatch_redo }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "design-bar-flex-column" }, [
            _c(
              "div",
              {
                ref: "status_message",
                staticClass: "design-bar-cell",
                attrs: { id: "design-bar-status-message" },
                on: {
                  animationend: function($event) {
                    _vm.clear_status_message()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.status_message))]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "design-bar-column" }, [
            _c("div", { staticClass: "design-bar-cell" }, [
              _c("input", {
                attrs: { type: "button", value: "Refresh" },
                on: { click: _vm.local_saves_load_from_local_storage }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "design-bar-cell design-bar-row" }, [
          _c("div", { staticClass: "design-bar-flex-column" }, [
            _c("div", { staticClass: "design-bar-cell" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selected_parts_list_name,
                      expression: "selected_parts_list_name"
                    }
                  ],
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.selected_parts_list_name = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                _vm._l(_vm.all_parts_lists, function(parts_list) {
                  return _c("option", { key: parts_list.pretty_name }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t\t" +
                        _vm._s(parts_list.pretty_name) +
                        "\n\t\t\t\t\t\t"
                    )
                  ])
                })
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "design-bar-column" }, [
            _c("div", { staticClass: "design-bar-cell" }, [
              _c("input", {
                attrs: { type: "button", value: "Load parts list" },
                on: { click: _vm.parts_lists_load_selected }
              })
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "design-bar-column" }, [
        _c("div", { staticClass: "design-bar-cell" }, [
          _c("span", [
            _c(
              "a",
              {
                attrs: {
                  href:
                    "shipdesigner.html#" + _vm.design_json_url_encoded_string
                }
              },
              [_vm._v("Link to this design")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "design-bar-cell" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.design_mode_enabled,
                expression: "design_mode_enabled"
              }
            ],
            attrs: { type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.design_mode_enabled)
                ? _vm._i(_vm.design_mode_enabled, null) > -1
                : _vm.design_mode_enabled
            },
            on: {
              change: function($event) {
                var $$a = _vm.design_mode_enabled,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.design_mode_enabled = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.design_mode_enabled = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.design_mode_enabled = $$c
                }
              }
            }
          }),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.design_mode,
                  expression: "design_mode"
                }
              ],
              attrs: {
                id: "design-bar-design-mode",
                disabled: !_vm.design_mode_enabled
              },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.design_mode = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            [
              _c("option", { attrs: { value: "none", disabled: "" } }, [
                _vm._v("Select Mode")
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "refit" } }, [
                _vm._v("Refit for")
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "compare" } }, [
                _vm._v("Compare with")
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "design-bar-flex-column" }, [
        _c("div", { staticClass: "design-bar-cell" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selected_design_name,
                  expression: "selected_design_name"
                }
              ],
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.selected_design_name = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            _vm._l(_vm.local_saves, function(blueprint) {
              return _c("option", { key: blueprint.pretty_name }, [
                _vm._v(
                  "\n\t\t\t\t\t" + _vm._s(blueprint.pretty_name) + "\n\t\t\t\t"
                )
              ])
            })
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "design-bar-cell" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selected_other_design_name,
                  expression: "selected_other_design_name"
                }
              ],
              attrs: { disabled: _vm.design_mode === "none" },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.selected_other_design_name = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            _vm._l(_vm.design_mode_local_saves, function(blueprint) {
              return _c("option", { key: blueprint.pretty_name }, [
                _vm._v(
                  "\n\t\t\t\t\t" + _vm._s(blueprint.pretty_name) + "\n\t\t\t\t"
                )
              ])
            })
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "design-bar-column" }, [
        _c("div", { staticClass: "design-bar-cell" }, [
          _c("input", {
            attrs: { type: "button", value: "Load save" },
            on: { click: _vm.local_saves_load_selected }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "button", value: "Delete save" },
            on: { click: _vm.local_saves_delete_selected }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: {
              type: "button",
              id: "design-bar-save-button",
              value: _vm.save_design_error
                ? _vm.save_design_error
                : "Save current design",
              disabled: _vm.save_design_error !== null
            },
            on: { click: _vm.local_saves_save_design }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "design-bar-cell" }, [
          _c("span", [_vm._v("Filter:")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.design_filter,
                expression: "design_filter"
              }
            ],
            attrs: {
              type: "checkbox",
              id: "filter-latest-for-name",
              value: "latest-for-name",
              disabled: "true"
            },
            domProps: {
              checked: Array.isArray(_vm.design_filter)
                ? _vm._i(_vm.design_filter, "latest-for-name") > -1
                : _vm.design_filter
            },
            on: {
              change: function($event) {
                var $$a = _vm.design_filter,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = "latest-for-name",
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.design_filter = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.design_filter = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.design_filter = $$c
                }
              }
            }
          }),
          _c("label", { attrs: { for: "filter-latest-for-name" } }, [
            _vm._v("Latest for name")
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.design_filter,
                expression: "design_filter"
              }
            ],
            attrs: {
              type: "checkbox",
              id: "filter-same-name",
              value: "same-name",
              disabled: "true"
            },
            domProps: {
              checked: Array.isArray(_vm.design_filter)
                ? _vm._i(_vm.design_filter, "same-name") > -1
                : _vm.design_filter
            },
            on: {
              change: function($event) {
                var $$a = _vm.design_filter,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = "same-name",
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.design_filter = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.design_filter = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.design_filter = $$c
                }
              }
            }
          }),
          _c("label", { attrs: { for: "filter-latest-for-name" } }, [
            _vm._v("Same name")
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23b102d6", { render: render, staticRenderFns: staticRenderFns })
  }
}